<template>
	<div>
		<table class="table" v-if="teamMembers != null">
			<thead>
				<tr>
					<th>Email</th>
					<th>Name</th>
					<th>Role</th>
					<th></th>
					<th>Actions</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="user in teamMembers.users" :key="user.id">
					<td>{{ user.email }}</td>
					<td>{{ user.name }}</td>
					<td>{{ ucFirst(user.pivot.role) }}</td>
					<td>
						<img
							src="/assets/img/ch-favicon.png"
							title="User has clickhint installed"
							v-if="user.has_clickhint_extension"
							height="15"
							width="15"
						/>
					</td>
					<td>
						<div class="dropdown show">
							<a
								href="#"
								class="d-block d-md-flex text-center settings-link dropdown-toggle align-items-center"
								role="button"
								id="dropdownMenuLink"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<i class="fa fa-cog brand-primary-gradient mr-2"></i>
								<span>Manage</span>
							</a>

							<div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
								<a href="#" @click.prevent="changeRole(user)" class="dropdown-item">
									<i class="fa fa-user mr-2"></i>
									Turn into {{ user.pivot.role == 'member' ? 'owner' : 'member' }}
								</a>
								<a href="#" @click.prevent="remove(user)" class="dropdown-item">
									<i class="fa fa-times mr-2"></i>
									Remove from team
								</a>
							</div>
						</div>
					</td>
				</tr>
				<tr v-if="teamMembers.invitations.length > 0">
					<th colspan="5" scope="row">Invitations</th>
				</tr>
				<tr v-for="invitation in teamMembers.invitations" :key="invitation.id">
					<td colspan="2">{{ invitation.email }}</td>
					<td>{{ ucFirst(invitation.role) }}</td>
					<td></td>
					<td>
						<div class="dropdown show">
							<a
								href="#"
								class="d-block d-md-flex text-center settings-link dropdown-toggle align-items-center"
								role="button"
								id="dropdownMenuLink"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<i class="fa fa-cog brand-primary-gradient mr-2"></i>
								<span>Manage</span>
							</a>

							<div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
								<a
									href="#"
									@click.prevent="deleteInvitation(invitation)"
									class="dropdown-item"
								>
									<i class="fa fa-times mr-2"></i>
									Delete
								</a>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<td colspan="5">
						<div class="d-flex justify-content-end align-items-center">
							<div class="d-flex align-items-center mr-2">
								<label for="email" class="mb-0 mr-2"><strong>Email</strong></label>
								<input
									type="text"
									id="email"
									class="form-control"
									v-model="inviteEmail"
								/>
							</div>
							<div class="d-flex align-items-center mr-2">
								<label for="role" class="mb-0 mr-2"><strong>Role</strong></label>
								<select v-model="inviteRole">
									<option value="member">Member</option>
									<option value="owner">Owner</option>
								</select>
							</div>
							<div>
								<button
									class="btn btn-primary"
									type="button"
									@click="invite"
									:disabled="adding"
								>
									<span v-if="adding"
										><i class="fa fa-btn fa-spinner fa-spin"></i> Adding</span
									>
									<span v-else>Add to team</span>
								</button>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import AdministrationMixin from '../AdministrationMixin';
export default {
	props: {
		team: Object,
		teamMembers: Object,
	},
	mixins: [AdministrationMixin],
	data() {
		return {
			inviteEmail: '',
			inviteRole: 'owner',
			adding: false,
		};
	},
	methods: {
		changeRole(user) {
			axios
				.put(`/api/admin/change-user-role/${this.team.id}/${user.id}`, {})
				.then((response) => {
					this.$emit('update-triggered', true);
				});
		},
		deleteInvitation(invitation) {
			axios
				.delete(`/api/admin/delete-invitation/${this.team.id}/${invitation.id}`)
				.then((response) => {
					this.$emit('update-triggered', true);
				});
		},
		invite() {
			if (!this.inviteEmail.includes('@')) {
				swal('danger', 'Not a valid email');
				return;
			}
			const postData = {
				email: this.inviteEmail,
				role: this.inviteRole,
			};
			this.adding = true;
			axios.post(this.inviteUrl, postData).then((response) => {
				this.$emit('update-triggered', true);
				this.adding = false;
			});
		},
		remove(user) {
			//
			swal(
				{
					title: `Are you sure you want to remove ${user.name} from ${this.team.name}?`,
					text: 'The action will be applied right away!',
					icon: 'danger',
					showCancelButton: true,
					confirmButtonColor: '#cd3537',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Remove',
				},
				async (result) => {
					if (result) {
						axios
							.delete(`/api/admin/delete-team-user/${this.team.id}/${user.id}`)
							.then((response) => {
								this.$emit('update-triggered', true);
							});
					}
				},
			);
		},
	},
};
</script>
